import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LOCAL_STORAGE_KEYS } from '@progressivebeef/shared/src/constants/AppConstants';
import RouteConstants from '@progressivebeef/shared/src/constants/RouteConstants';
import RecordBinderHelper from '@progressivebeef/shared/src/helpers/RecordBinderHelper';

export const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const user = useSelector((state) => state.authentication?.user);
  
  const redirectRoute = useMemo(() => {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const pinCode = localStorage.getItem(LOCAL_STORAGE_KEYS.PIN_CODE);
    const selectedFeedyard = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SELECTED_FEEDYARD,
    );
    const isLocked = localStorage.getItem(LOCAL_STORAGE_KEYS.IS_LOCKED);
    const currentPath = location.pathname;

    // Check if user is not authenticated
    if (!accessToken) {
      return RouteConstants.LOGIN;
    }

    // Check if PIN is not set
    if (!pinCode) {
      if (currentPath !== RouteConstants.GENERATE_PIN) {
        return RouteConstants.GENERATE_PIN;
      }
    } else {
      // Check if feedyard is not selected
      if (!selectedFeedyard) {
        if (currentPath !== RouteConstants.FEEDYARD_LIST) {
          return RouteConstants.FEEDYARD_LIST;
        }
      } 
      // Check if app is locked
      else if (isLocked === 'true') {
        if (
          currentPath !== RouteConstants.LOCK_SCREEN &&
          currentPath !== RouteConstants.LOGOUT
        ) {
          return RouteConstants.LOCK_SCREEN;
        }
      } else {
        const isRecordBinderRoute =
          currentPath === '/RecordBinder' ||
          currentPath === '/RecordDetail' ||
          currentPath === '/AddRecord';

        if (isRecordBinderRoute) {
          if (!RecordBinderHelper.canUserViewRecordBinder(user)) {
            return RouteConstants.DASHBOARD;
          }

          if (currentPath === '/AddRecord') {
            if (!RecordBinderHelper.canUserWriteRecordBinder(user)) {
              return '/RecordBinder';
            }
          }
        }
      }
    }

    return null; // No redirect needed
  }, [location.pathname, user]);

  if (redirectRoute) {
    return <Navigate to={redirectRoute} state={{ from: location }} replace />;
  }

  return children;
};
